export default __webpack_public_path__ + "static/media/btn-index-home.18cd21fa.svg";